export const handleCheckboxChange = (site, setSelectedSites) => {
  const id = site.id;
  const nom = site.data().nom;
  const adresse = site.data().adresse;

  setSelectedSites((prevSelected) => {
    // Vérifie si le site est déjà sélectionné
    const siteExists = prevSelected.some((selectedSite) => selectedSite.id === id);

    if (siteExists) {
      // Si le site est déjà sélectionné, le retirer
      return prevSelected.filter((selectedSite) => selectedSite.id !== id);
    } else {
      // Si le site n'est pas encore sélectionné, l'ajouter
      return [...prevSelected, { id, nom, adresse }];
    }
  });
};